import type { EntregaMediaPort } from '../domain/ports/EntregaPorts.ts';
import {
  assertVerifiedMediaStored,
  persistVerifiedMediaBlob,
  resolveVerifiedMediaId,
} from '@src/modules/platform/local-media/application/verifiedMediaBlob.ts';

export async function persistVerifiedEntregaBlob(
  media: EntregaMediaPort,
  blob: Blob,
  label: string,
  currentId?: string | null,
): Promise<string> {
  return persistVerifiedMediaBlob(media, blob, label, currentId);
}

export async function assertEntregaMediaStored(
  media: EntregaMediaPort,
  mediaId: string | null | undefined,
  label: string,
): Promise<void> {
  return assertVerifiedMediaStored(media, mediaId, label);
}

export async function resolveEntregaMediaId(
  media: EntregaMediaPort,
  blob: Blob | null,
  currentId: string | null | undefined,
  label: string,
): Promise<string> {
  return resolveVerifiedMediaId(media, blob, currentId, label);
}
